/* eslint-disable max-len */
import React from 'react';
import { useIntl } from 'react-intl';
import Media from 'react-media';
import PricingHero from './components/PricingHero';
import Pipers from '../../components/Pipers/Pipers';
import { Layout } from '../../contexts/LayoutContext';
import CompareHolder from '../landing/components/CompareHolder';
import mediaQueries from '../../utils/mediaQueries';
import WhereToPostSection from '../landing/components/WhereToPostSection';

const PricingView = () => {
  const intl = useIntl();
  return (
    <Media queries={mediaQueries}>
      {(matches) => (
        <Layout
          title={intl.formatMessage({
            id: 'k.seo.title',
            defaultMessage: '{titlePage} Schedule and manage your business social media.',
          }, {
            titlePage: intl.formatMessage({
              id: 'newPricing.title',
              defaultMessage: 'Pricing',
            }),
          })}
          accessOnTrialEnds
        >
          <PricingHero
            Piper={Pipers.Piper1}
            title={intl.formatMessage({
              id: 'newPricing.title',
              defaultMessage: 'Pricing',
            })}
          />
          {matches.mdUp && (
            <CompareHolder show />
          )}
          {matches.mdDownLess && <WhereToPostSection />}
        </Layout>
      )}
    </Media>
  );
};

export default PricingView;
